// extracted by mini-css-extract-plugin
module.exports = {"banner":"Partners_banner__2faLv","btn":"Partners_btn__d7iZI","itemsOnImg":"Partners_itemsOnImg__2zFRM"};